<template>
  <div>
    <spinner-overlay
      :show-overlay="loading"
      :show-spinner="loading"
    />
    <account-credits hide-plan />
    <div v-if="!loading">
      <current-subscription-details
        v-if="accountStatus.subscribed"
      />
      <select-subscription-plan v-else />
    </div>
  </div>
</template>

<script>
import CurrentSubscriptionDetails from '@/components/CurrentSubscriptionDetails'
import SelectSubscriptionPlan from '@/components/SelectSubscriptionPlan'
import SpinnerOverlay from '@/components/SpinnerOverlay.vue'
import AccountCredits from '@/components/AccountCredits'

export default {
  name: 'AccountStatus',
  components: {
    AccountCredits,
    CurrentSubscriptionDetails,
    SelectSubscriptionPlan,
    SpinnerOverlay
  },
  data: function () {
    return {
      loading: true
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_accountStatus']).then(async () => (this.loading = false))
    this.mapStates(['accountStatus'])
  }
}
</script>
<style lang="scss" scoped></style>
